export default __webpack_public_path__ + "static/media/thumb.1a65ff7f.png";